//import React from 'react';
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CardDescription from "./Card";
import SampleData from "../assets/sampleData";

function Jobcard(props) {
  const { productList, existingJobList } = props;

  const [productData, setProductData] = useState();
  useEffect(() => {
    setProductData(productList);
  }, [productList]);

  const refs = productData?.reduce((acc, value) => {
    acc[value.id] = React.createRef();
    return acc;
  }, {});
  //const refs = React.createRef();

  function handleClick(id) {
    refs[id].current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  return (
    <>
      <div
        className="jobcard"
        style={{
          backgroundColor: "#F7F7F7",
        }}
      >
        {productData?.map((item, index) => {
          return (
            <div
              key={item?.id}
              className="mainDiv"
              onClick={() => handleClick(item?.id)}
            >
              <img
                style={{
                  borderRadius: "6px",
                }}
                alt=""
                src={item?.image}
              />
              <Typography
                id="two-lines-text-css"
                style={{fontSize: '15px'}}
                pt={1}
              >
                {item.title}
              </Typography>
            </div>
          );
        })}
      </div>
      <Grid container px={3} mt={2}>
        <CardDescription
          productList={productList}
          existingJobList={existingJobList}
          ref={refs}
        />
      </Grid>
    </>
  );
}
export default Jobcard;
